
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCoupons ,searchCoupons} from "../api/ApiService";

export const initialState = {
  loading: false,
  hasErrors: false,
  status: "",
  coupon: [],
  searchCoupon:[],
  searchCouponStatus:"",
  searchLoading:false
};

export const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    startCouponLoading: (state, action) => {
      state.loading = action.payload;
    },
    getCouponSuccess: (state, action) => {
      state.coupon = action.payload;
      state.loading = false;
      state.hasErrors = false;
      state.status = true;
    },
    getCouponFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoupon.pending, (state) => {
        state.loading = true;
        state.hasErrors = false;
        state.status = "loading";
      })
      .addCase(fetchCoupon.fulfilled, (state, action) => {
        state.coupon = action.payload.coupons;
        state.loading = false;
        state.status = "loaded";
      })
      .addCase(fetchCoupon.rejected, (state, action) => {
        state.loading = false;
        state.hasErrors = true;
        state.status = "error";
      })
      .addCase(searchCoupon.pending, (state) => {
        state.searchLoading = true;
        state.hasErrors = false;
        state.searchCouponStatus = "loading";
      })
      .addCase(searchCoupon.fulfilled, (state, action) => {
        state.searchCoupon = action.payload.coupons;
        state.searchLoading = false;
        state.searchCouponStatus = "loaded";
      })
      .addCase(searchCoupon.rejected, (state, action) => {
        state.searchLoading = false;
        state.hasErrors = true;
        state.searchCouponStatus = "error";
      });

  },
});

export const fetchCoupon = createAsyncThunk(
  'coupon/fetchCoupon', 
  async (body) => {
    const data = await fetchCoupons(body); 
    return data;
  }
);
export const searchCoupon = createAsyncThunk(
  'coupon/searchCoupon', 
  async (body) => {
    const data = await searchCoupons(body); 
    return data;
  }
);


export default couponSlice.reducer;
